import enhanceFamuJsu from './famuJsuGameOfWeek';

// article_id -> enhancer(container) returning a cleanup function
export const ARTICLE_ENHANCERS = {
  iart_2cebae571d1d: enhanceFamuJsu
};
